
<!-- Объекты -->
<!-- span не использовать - ломает set_table_width (колонка становится не сужаемой) -->

<template>
	<div class="d-flex h-100 w-100" style="gap: 1rem;position: relative;">
		<div ref="table_element" v-on:keyup.enter="apply_filters" class="base_objects main-container main-container_content">
	
			<showAttr ref="show_attr" :keys_if_all_attrs_hidden="keys_if_all_attrs_hidden"/>
			<setAttrMany :essence="essence" ref="set_attr_many"/>
			<clearAttrsMany :essence="essence" :service="service" ref="clear_attrs_many" :attrs="attrs" v-on:clear_attrs_many="clear_attrs_many"/>
			<importAttrFromXLSX :essence="essence" ref="import_attr_from_xlsx"/>
			<setGroupMany :essence="essence" ref="set_group_many" :service="service" v-on:need_refresh="() => refresh_objects()"/>
			<setGroupAutoMany ref="set_group_auto_many" v-on:group="set_group_auto_many"/>
			<exportToTable :essence="essence" ref="export_to_table"/>
			<setEvaluatingUsingCodeMany ref="set_evaluating_using_code_many" :essence="essence"/>
			<setFunctionalGroupSubGroupMany ref="set_functional_group_sub_group_many" :essence="essence"/>
	
			<slot name="modal_dialogs"/>
	
			<b-navbar class="px-0">

				<b-navbar-brand>

					<h4>{{this.$route.meta.title}}</h4>

				</b-navbar-brand>

				<b-nav pills class="ml-auto">

					<slot name="first_toplevel_items"/>

					<b-button variant="outline-primary" v-on:click="show_attr" title="Выбор ценообразующих факторов" v-b-tooltip:fullscreen.hover.bottomright><base-icon name="settings" /></b-button>
					<b-button variant="outline-primary" v-b-toggle.query title="Фильтр" v-b-tooltip:fullscreen.hover.bottomright>
						<base-icon :name="
							filter_opened ? 'filter_alt_close' : filter_button_colored ? 'filter_alt_active' : 'filter_alt'
						" />
					</b-button>

					<b-dropdown v-if="service != 'cadastral_analogues_expensive' && !without_edit_many" variant="outline-primary" v-b-tooltip:fullscreen.hover.bottomright="'Множественное редактирование'" text="Множественное редактирование" menu-class="dropdown-menu" right>

						<template #button-content>
							<base-icon name="pen" />
						</template>

						<b-dropdown-item v-if="with_delete_many && check_roles([ 'grouping', 'model' ])" v-on:click="delete_many">Исключение объектов-аналогов</b-dropdown-item>

						<template v-if="service == 'cadastral_objects'">
							<b-dropdown-item v-if="check_roles([ 'grouping' ])" v-on:click="import_attr_from_xlsx">Импорт значений ценообразующих факторов</b-dropdown-item>	
							<b-dropdown-item v-if="check_roles([ 'grouping' ])" v-on:click="clear_attrs_many_modal">Сброс значений ценообразующих факторов</b-dropdown-item>
							<b-dropdown-item v-if="with_group && check_roles([ 'grouping' ])" v-on:click="set_evaluating_using_code_many">Сегмент / Код расчета вида использования</b-dropdown-item>
							<b-dropdown-item v-if="has_oks && with_group && check_roles([ 'grouping' ])" v-on:click="set_functional_group_sub_group_many">Функциональная группа / подгруппа</b-dropdown-item>
							<slot name="many_edit_attr_items"/>	
						</template>

						<b-dropdown-item v-if="with_group && check_roles([ 'grouping' ])" v-on:click="set_group_many">Оценочная группа / подгруппа. Присвоение значений из справочника</b-dropdown-item>

						<b-dropdown-item v-if="with_group && check_roles([ 'grouping' ])" v-on:click="() => get_set_group_auto_many_params()">Группировка</b-dropdown-item>

						<slot name="many_edit_items"/>

					</b-dropdown>

					<b-button variant="outline-primary" v-on:click="export_to_table()" v-if="!$root.readonly" title="Экспорт таблицы" v-b-tooltip:fullscreen.hover.bottomright><base-icon name="download" /></b-button>

					<b-button variant="outline-primary" v-on:click="clear_sort" v-if="sort_by != null" v-b-tooltip:fullscreen.hover.bottomright title="Сброс сортировки"><base-icon name="sort_cancel" /></b-button>

				</b-nav>
			</b-navbar>
	
			<b-collapse id="query" ref="filters_container" v-model="filter_opened">
	
				<filters v-if="attrs.length" ref="filters" :essence="service" :attrs="attrs" :storage_name_filters="storage_name_filters" :storage_name_filters_name="storage_name_filters_name" query_key_prefix="current_version." :with_status_filter="with_status_filter" v-on:need_refresh="refresh_by_filters" v-on:ready="filters_ready">
	
					<template v-slot:additional_save_controls>
	
						<slot name="filters_additional_save_controls"/>
					
					</template>
	
				</filters>
	
			</b-collapse>
	
			<!-- <v-context-menu ref="context_menu">
	
				<b-dropdown-item v-if="single_element_url" v-on:click="$router.push('/' + single_element_url + '/' + selected_object.id)">Открыть</b-dropdown-item>
				<b-dropdown-item v-if="single_element_url" v-on:click="() => open_in_new_tab('/' + single_element_url + '/' + selected_object.id)">Открыть в новой вкладке</b-dropdown-item>
				<b-dropdown-item v-on:click="() => $copyText(selected_text)">Копировать</b-dropdown-item>
				<slot name="activities" :data="selected_object"/>
	
			</v-context-menu> -->
	
			<b-table
				v-if="attrs_visible.length"
				id="table"
				ref="table"
				class="elements" small hover
				:fields="attrs_visible"
				:items="objects"
				v-on:sort-changed="sort_changed" :sort-by="sort_by" :sort-desc="sort_desc" no-local-sorting primary-key="name"
				v-on:row-dblclicked="double_click"
				@hook:mounted="table_init"
				>
				<!-- v-on:row-contextmenu="context_menu" -->
	
				<template #table-busy>
	
					<div class="text-center text-primary my-2">
	
						<b-spinner class="align-middle"></b-spinner>
	
					</div>
	
				</template>
	
				<template v-slot:head()="data">
					
					<div :id="data.field.key" class="table_head_div">
	
						<div draggable="true" v-on:dragstart="drag_column_begin" v-on:drop="drop_column" v-on:dragover="drag_column" :id="data.field.key">
	
							{{ data.label }}
	
						</div>
	
					</div>
	
				</template>
	
				<template v-slot:cell()="data">

					<div :class="data.field.type == 'number' && 'text-right'">
	
						<div v-if="data.field.key == 'attrs.KeyParameters.KeyParameter' || data.field.key == 'attrs.SubConstructions.SubConstruction.KeyParameter'" class="table_div">
		
							<div v-if="data.value.Value == null">
		
								<div v-for="( elem, index ) in data.value" :key="index">
		
									{{ format_key_parameter(elem) }}
		
								</div>
		
							</div>
		
							<div v-else>
		
								{{ format_key_parameter(data.value) }}
		
							</div>
		
						</div>
						<div v-else-if="data.field.key == 'attrs.ParentOKS.ElementsConstruct.Material' || data.field.key == 'attrs.ElementsConstruct.Material' || data.field.key == 'attrs.ParentOKS.ElementsConstruct.Material.Wall' || data.field.key == 'attrs.ElementsConstruct.Material.Wall'" class="table_div">
		
							<div v-if="Array.isArray(data.value)">
		
								<span v-for="( elem, index ) in data.value" :key="index">{{ format_reference(data.field.reference, elem.Wall) }}</span> <!-- Такое ощущение, что справочника у типа и нет -->
								
							</div>
							<div v-else-if="data.field.key == 'attrs.ParentOKS.ElementsConstruct.Material.Wall' && data.item && data.item.attrs.ParentOKS && data.item.attrs.ParentOKS.ElementsConstruct && Array.isArray(data.item.attrs.ParentOKS.ElementsConstruct.Material)">
		
								<span v-for="( elem, index ) in data.item.attrs.ParentOKS.ElementsConstruct.Material" :key="index">{{ format_reference(data.field.reference, elem.Wall) }}</span> <!-- Такое ощущение, что справочника у типа и нет -->
		
							</div>
							<div v-else-if="data.field.key == 'attrs.ElementsConstruct.Material.Wall' && data.item && data.item.attrs.ElementsConstruct && Array.isArray(data.item.attrs.ElementsConstruct.Material)">
		
								<span v-for="( elem, index ) in data.item.attrs.ElementsConstruct.Material" :key="index">{{ format_reference(data.field.reference, elem.Wall) }}</span> <!-- Такое ощущение, что справочника у типа и нет -->
		
							</div>
							<div v-else>
		
								{{ format_reference(data.field.reference, data.value) }}
		
							</div>
		
						</div>
						<div v-else-if="data.field.type_info == 'Кадастровый номер объекта недвижимости' || data.field.name == 'Кадастровый номер' || data.field.name == 'ЦОФ_Кадастровый номер'" class="table_div">
		
							<div v-if="data.value != null && data.value != ''">
		
								<router-link v-if="typeof data.value == 'string'" :to="'/objects/cadastral_number/' + data.value">{{ data.value }}</router-link>
								<div v-else v-for="( elem, index ) in data.value" :key="index"><router-link :to="'/objects/cadastral_number/' + elem">{{ elem }}</router-link></div>
		
							</div>
		
						</div>
						<div v-else-if="service == 'cadastral_analogues' && data.field.key == 'attrs.group_code'" class="table_div word-break-word">
							
							<div v-if="data.value != null && data.value != ''">
								
								<router-link :to="'/analogues/' + data.item.id">{{ data.value }}</router-link>
		
							</div>
		
						</div>
						<div v-else-if="data.field.key == 'attrs.Name'" class="table_div">
							
							<div v-if="data.item.attrs.ObjectType == '002001001000'">
		
								{{ format_reference(parcel_type_reference, data.value) }}
		
							</div>
							<div v-else>{{ data.value }}</div>
		
						</div>
						<div v-else class="table_div">
		
							<div class="keep-spaces">{{ format_value(data.value, data.field.key, data.field.type, data.field.reference) }}</div>
		
						</div>
						
					</div>
	
				</template>
	
			</b-table>

			<div class="footer">
				<div ref="footer_scroll" class="w-100 footer_scroll" style="overflow-x: auto;"><div v-if="tableWidth" :style="{ width: tableWidth + 'px', height: '1px' }"></div></div>
				<b-row class="footer_content small natural-400" style="font-size: 0.75rem">
		
					<b-col cols="6" class="footer_count">
		
						Найдено: {{count}} записей. Показывать на странице по:
						<v-select v-model="per_page" class="v_select_up" :options="[5, 10, 50]" @input="set_per_page" :clearable="false" :searchable="false" style="width: 4.625rem;height: 1.5rem;display: inline-block" />
		
					</b-col>
				
					<b-col cols="6">
		
						<b-pagination ref="paginator" align="right" v-model="current_page" :per-page="per_page" :total-rows="count" aria-controls="table" v-on:change="refresh" first-number last-number>
		
							<template #prev-text><b-icon icon="chevron-left"></b-icon></template>
							<template #next-text><b-icon icon="chevron-right"></b-icon></template>
		
						</b-pagination>
		
					</b-col>
		
				</b-row>
			</div>
	
		</div>
		<steps ref="steps" v-if="service == 'cadastral_analogues' || service == 'cadastral_analogues_expensive'"
			:steps_items="steps_items" v-on:set_active_step="set_active_service"
		/>
	</div>

</template>

<script>

import api from "../../../api"
import main_tree from "../../../api/main_tree"
import attrs from "../../../api/attrs"
import showAttr from "./attrs/show"
import filters from "../../filters"
import setAttrMany from "./edit_many/set_attr_many"
import clearAttrsMany from "./edit_many/clear_attrs_many"
import importAttrFromXLSX from "./import_attr_from_xlsx"
import exportToTable from "./export_to_table"
import setGroupMany from "./edit_many/set_group_many"
import setGroupAutoMany from "../../widgets/set_group_auto_many.vue"
import setEvaluatingUsingCodeMany from "./edit_many/set_evaluating_using_code_many"
import setFunctionalGroupSubGroupMany from "./edit_many/set_functional_group_sub_group_many"
import steps from "../../widgets/steps"
import Table_controller from "../../../api/table"

export default
{
	components :
	{
		showAttr,
		setGroupMany,
		setGroupAutoMany,
		filters,
		setAttrMany,
		clearAttrsMany,
		importAttrFromXLSX,
		exportToTable,
		setEvaluatingUsingCodeMany,
		setFunctionalGroupSubGroupMany,
		steps,
	},

	props :
	{
		service : String,
		essence : String,
		essence_name_many : String, // Множественное число
		essence_name_genetive_case : String, // Родительный падеж названия сущности, с маленькой буквы
		essence_name_for_plural_1 : String, // Родительный падеж, множественное число, 1 элемент, с маленькой буквы
		essence_name_for_plural_234 : String, // Родительный падеж, множественное число, 2, 3, 4 элемента, с маленькой буквы
		essence_name_for_plural_others : String, // Родительный падеж, множественное число, 5 и больше элементов, 0 элементов, с маленькой буквы
		single_element_url : String,
		without_edit_many : { type : Boolean, default : () => false },
		with_delete_many : { type : Boolean, default : () => false },
		delete_many_additional_message : { type : String, default : () => null },
		with_status_filter : { type : Boolean, default : () => false },
		with_group : { type : Boolean, default : () => false },
		keys_if_all_attrs_hidden : { type : Array, default : () => [ "attrs.CadastralNumber", "attrs.Name" ] },
		exclude_keys : { type : Array, default : () => [] },
		additional_query : Object,
	},

	filters :
	{
		round2(value)
		{
			return api.round2(value)
		}
	},

	computed :
	{
		with_xml_export()
		{
			return process.env.VUE_APP_RELEASE != "true"
		},

		group_id()
		{
			var group_id = ""

			if(name != "expensives" && this.$root.current_group)
				group_id = this.$root.current_group.group_id

			return group_id
		},

		storage_name_filters()
		{

			return api.storage.name(this, "filters_" + this.group_id)
		},

		storage_name_filters_name()
		{
			return api.storage.name(this, "filters_name_" + this.group_id)
		},
	},

	data()
	{
		var steps_items =
		[
			{
				id : 'analogues',
				title : "Сравнительный подход",
				subtitle : "Метод статистического (регрессионного) моделирования",
			},
			{
				id : 'analoguesprofitable',
				title : "Доходный подход",
				subtitle : "Метод прямой капитализации",
			},
		]

		if(api.has_oks())
			steps_items.push(
				{
					id : 'expensives',
					title : "Затратный подход",
					subtitle : "Метод сравнительной единицы",
				})

		return {
			
			attrs : [],
			attrs_in_query : [],
			attrs_visible : [],
			key_parameter_type_reference : {},
			parcel_type_reference : {},
			objects : [],
			selected_object : {},
			selected_text : null,

			is_sort : false,
			sort_by : null,
			sort_desc : null,
			per_page : 10,
			current_page : 1,
			count : 0,
			object_word : "",
			from : 0,
			to : 0,

			and_query : null,
			extra : {},

			steps_items : steps_items,

			wait : false,

			filter_opened : false,
			filter_button_colored : false,

			has_oks : true,

			tableWidth: null
		}
	},

	mounted()
	{
		const data = api.cache.paginator.load(this)
		const name = this.$route.name

		if(data.per_page == null)
			this.per_page = 10
		else
			this.per_page = data.per_page

		data.current_page = 1

		this.sort_by = data.sort_by
		this.sort_desc = data.sort_desc
		this.current_page = data.current_page
		this.has_oks = api.has_oks()

		if (this.service == 'cadastral_analogues' || this.service == 'cadastral_analogues_expensive')
			this.$refs.steps.set_active_step({id : this.$route.name})

		if(name != "expensives" && this.$root.current_group)
		{
			const group_id = this.$root.current_group.group_id

			if(group_id != null)
			{
				const group_full_name = this.$root.current_group.full_name
				const key = "cadastral_group"

				this.and_query = { "and" : [{"keys":[key],"operation":key,"args":[group_id,group_full_name]}] }
			}
		}

		return this.refresh_attrs()
	},

	methods :
	{
		check_roles(roles)
		{
			return api.check_roles(this, roles)
		},

		save_to_storage()
		{
			api.storage.set(this, api.storage.name(this, "attr_visible_keys"), JSON.stringify(this.attrs_visible.map(attr => attr.key)))
		},

		get_query()
		{
			var raw = {}

			if(Object.keys(raw).length == 0)
				raw = null

			if(this.$refs.filters)
				this.filter_button_colored = this.$refs.filters.applied

			return this.$refs.filters.get_query(this.additional_query, raw, true, this.extra, this.and_query)
		},

		go_back()
		{
			api.back.go(this)
		},

		// #############################################################################
		// Объекты

		delete_many()
		{
			var msg = `Исключить ${this.essence_name_many || "объекты"}?`

			if(this.delete_many_additional_message != null)
				msg += " " + this.delete_many_additional_message

			this.$bvModal.msgBoxConfirm(
				msg,
				{
					title : "Подтверждение исключения",
					okVariant : "danger",
					okTitle : "Да",
					cancelVariant : "outline-primary-secondary",
					cancelTitle : "Нет",
					hideHeaderClose : false,
					centered : true
				})
				.then(
					value =>
					{
						if(value)
						{
							this.wait = true

							api.call(this, this.service, "set_used_many", { query : this.get_query(), value : false, full : false },
								() =>
								{
									this.wait = false
									api.show_notification(this, `Выбранные ${this.essence} исключены`)
									this.refresh(1, false, true)

									main_tree.create(this)
								})
						}
					})
		},

		refresh(current_page = 1, is_button_pressed = false, refresh_count = false) // Для фильтров
		{
			var promise = this.refresh_objects(current_page, is_button_pressed)

			if(refresh_count)
				promise = promise.then(() => this.refresh_count())

			return promise
		},

		refresh_attrs()
		{
			var _attrs
			var attrs_in_query
			var attrs_visible

			return attrs.get(this, this.$props.keys_if_all_attrs_hidden)
				.then(
					data =>
					{
						_attrs = data.attrs.filter(attr => ! this.exclude_keys.includes(attr.key))
						attrs_in_query = data.attrs_in_query.filter(attr => ! this.exclude_keys.includes(attr.key))
						attrs_visible = data.attrs_visible.filter(attr => ! this.exclude_keys.includes(attr.key))
						this.parcel_type_reference = data.parcel_type_reference
						this.key_parameter_type_reference = data.key_parameter_type_reference
					})
				.then(
					() =>
					{
						var check_attr

						if(this.service == "cadastral_objects")
							check_attr = attr => attr.show == null || attr.show.cadastral_objects
						else if(this.service == "cadastral_analogues")
							check_attr = attr => attr.show && attr.show.analogues
						else if(this.service == "cadastral_analogues_expensive")
							check_attr = attr => attr.show && attr.show.analogues_expensive

						this.attrs = _attrs.filter(check_attr)
						this.attrs_in_query = attrs_in_query.filter(check_attr)
						this.attrs_visible = attrs_visible.filter(check_attr)
					})
		},

		table_init()
		{
			this.$on("column_order_has_been_changed", () => this.save_to_storage())

			this.table_controller = new Table_controller(this, this.$refs.table.$el, this.$refs.table_element.clientWidth)

			new ResizeObserver((entries) => {
				this.tableWidth = entries[0].target.clientWidth
			}).observe(this.$refs.table.$el)

			new ResizeObserver(() => {
				if (this.$refs.table)
				{
					this.table_controller.resize(this.$refs.table_element.clientWidth)
				}
			}).observe(this.$el)
						
			this.$refs.footer_scroll && this.$refs.footer_scroll.addEventListener('scroll', (e) => {
				this.$refs.table.$el.style.transform = `translateX(${-e.target.scrollLeft}px)`
			})
		},

		set_resizable_and_width()
		{
			this.table_controller.set_width()
		},

		reset_table_width()
		{
			this.table_controller.reset()
		},

		get_sort_by()
		{
			var sort_by = this.sort_by

			if(sort_by == null || sort_by == "")
				return null

			if(sort_by != "$natural")
				sort_by = "current_version." + sort_by

			return sort_by
		},

		refresh_objects(current_page = 1, is_button_pressed = false)
		{
			//this.wait = true

			this.$refs.filters.save_to_local_storage()

			const skip = (current_page - 1) * this.per_page // Бек нумерует с 0
			var params = {

				query : this.get_query(),
				skip : skip,
				is_raw : true

			}

			if(this.per_page > 0)
				params.limit = this.per_page

			const sort_by = this.get_sort_by()

			if(sort_by != null)
			{
				// Важно, что this.sort_by, т.к. get_sort_by добавляет "current_version"
				const attr = this.attrs.find(attr => attr.key == this.sort_by)

				params.sort_by = sort_by
				params.is_desc = this.sort_desc

				if(attr != null)
				{
					if(params.extra == null || params.extra == undefined)
						params.extra = {}
					else
						params.extra = api.deep_clone(params.extra)

					params.extra.sort_type = attr.type
				}
			}

			const data = {
					
					current_page : current_page,
					per_page : this.per_page,
					sort_by : this.sort_by,
					sort_desc : this.sort_desc,

				}
			api.cache.paginator.save(this, data)

			this.$emit("before_refresh_objects")

			return api.call(this, this.service, "get_many", params,
				response =>
				{
					var objects = []

					response.data.forEach(
						obj =>
						{
							var arrays =
							[
								{ attrs : obj.current_version.attrs.SubParcels, key : "SubParcel" },
								{ attrs : obj.current_version.attrs.SubBuildings, key : "SubBuilding" },
								{ attrs : obj.current_version.attrs.SubFlats, key : "SubFlat" },
								{ attrs : obj.current_version.attrs.SubConstructions, key : "SubConstruction" },
								{ attrs : obj.current_version.attrs.ZonesAndTerritories, key : "ZoneAndTerritory" },
							]
							if(obj.current_version.attrs.PositionInObject_)
								arrays.push({ attrs : obj.current_version.attrs.PositionInObject_.Levels, key : "Level" })

							arrays.forEach(
								elem =>
								{
									try
									{
										elem.attrs[elem.key] = api.prepare_array_of_objects_for_table(elem.attrs, elem.key)
									}
									// eslint-disable-next-line
									catch {}
								})

							let desc =
							{
								id : obj.id,
								name : obj.name,
								status : obj.current_version.status,
								attrs : obj.current_version.attrs,
							}

							objects.push(desc)
						})

					if(objects.length == 0 && is_button_pressed)
						api.show_notification(this, "Объекты, соответствующие заданным условиям фильтрации, не найдены")
					
					if(skip == 0 && objects.length == 0)
					{
						this.from = 0
						this.to = 0
					}
					else
					{
						this.from = skip + 1 // Отображаемая нумерация с 1
						this.to = this.from + objects.length - 1
					}

					this.objects = objects
					this.$refs.paginator.currentPage = current_page
					//this.wait = false
				})
		},

		refresh_count()
		{
			this.count = null

			const params = {

				query : this.get_query(),

			}
			
			return api.call(this, this.service, "get_many_count", params,
					response =>
					{
						this.count = response.count
						this.object_word = api.words.object.accusative(this.count)
					},
					( self, response ) =>
					{
						if(response.exception == "BadRegexp")
							return

						return api.show_error_box(self, response)
					})
		},

		set_per_page(per_page)
		{
			this.per_page = per_page

			this.refresh_objects()
		},

		// #############################################################################
		// Атрибуты

		show_attr()
		{
			this.$refs.show_attr.execute(this)
		},

		// #############################################################################
		// Фильтры

		filters_ready()
		{
			this.$refs.filters.refresh()
				.then(
					() =>
					{
						if(this.$route.query && this.$route.query.query_force)
						{
							const query = this.$route.query.query_force

							this.$refs.filters.load_from_foreign_storage({ query : query }, false)
						}
						else
							this.$refs.filters.load_from_local_storage(false)
					})
				.then(() => this.refresh_objects(this.current_page))
				.then(() => this.refresh_count())
		},

		refresh_by_filters()
		{
			this.$refs.filters_container.toggle()
			this.$refs.filters.save_to_local_storage()
			this.refresh(1, true, true)
		},

		apply_filters()
		{
			const modal_count = this.$el.querySelectorAll(".modal.in").length + this.$el.querySelectorAll("div .vm--modal").length

			if(modal_count == 0)
				this.$refs.filters.apply()
		},

		// #############################################################################
		// Экспорт

		export_to_table()
		{
			this.$refs.export_to_table.execute()
		},

		// #############################################################################
		// Импорт

		import_attr_from_xlsx()
		{
			this.$refs.import_attr_from_xlsx.execute()
		},

		// #############################################################################
		// Форматирование полей

		format_reference(ref, value)
		{
			return api.format_reference(ref, value)
		},

		format_value(value, key, type, reference = null)
		{
			const cost_keys = [
				"attrs.uprs",
				"attrs.corrected_price",
				"attrs.CadastralCost.Value",
				"attrs.cost",
				"attrs.cost_comparative",
				"attrs.cost_expensive",
				"attrs.cost_profitable",
				"attrs.UPKS",
				"attrs.UPKS_comparative",
				"attrs.UPKS_expensive",
				"attrs.UPKS_profitable",
			]

			if(cost_keys.includes(key))
				return api.format_cost(value.toString(), "", "")

			return api.format_value(value, type, reference)
		},

		format_value_from_data(data, key, value_type, reference = null)
		{
			return api.format_value_from_data(data, key, value_type, reference)
		},

		// #############################################################################
		// Множественное редактирование

		set_attr_many()
		{
			this.$refs.set_attr_many.execute()
		},

		clear_attrs_many_modal()
		{
			this.$refs.clear_attrs_many.execute()
		},

		clear_attrs_many(ev)
		{
			const params = {
				
				attrs : ev.attrs_selected,
				query : this.get_query(),

			}

			api.call_long_operation(this, this.essence + ". Множественное редактирование. Сброс значений ценообразующих факторов", this.service, "clear_attrs_in_current_version_many", params,
			response =>
			{
				api.open_response_url(response)
				this.refresh_objects()
			},
			{ success_msg : "Сброс значений выбранных ценообразующих факторов завершен" }
			)
		},

		// #############################################################################
		// Перетаскивание колонок

		drag_column_begin(event)
		{
			this.drag_column_id = event.srcElement.id
		},

		drag_column(event)
		{
			event.preventDefault();
		},

		drop_column(event)
		{
			var to_column_id = event.srcElement.id

			var drag_id = null
			var to_id = null

			this.attrs_visible.forEach(
				( elem, index ) =>
				{
					if(elem.key == this.drag_column_id)
						drag_id = index

					if(elem.key == to_column_id)
						to_id = index
				})

			var drag_attr = this.attrs_visible[drag_id]

			if(drag_id < to_id)
			{
				this.attrs_visible.splice(to_id + 1, 0, drag_attr)
				this.attrs_visible.splice(drag_id, 1)
			}
			else
			{
				this.attrs_visible.splice(to_id, 0, drag_attr)
				this.attrs_visible.splice(drag_id + 1, 1)
			}
		},

		// #############################################################################
		// Разное

		format_key_parameter(elem)
		{
			return api.format_key_parameter(elem, this.key_parameter_type_reference)
		},

		sort_changed(ctx)
		{
			if(! this.is_sort)
			{
				this.is_sort = true
			}

			this.sort_by = ctx.sortBy
			this.sort_desc = ctx.sortDesc
			
			return this.refresh_objects(this.current_page)
		},

		clear_sort()
		{
			this.is_sort = false

			this.sort_by = null
			this.sort_desc = null

			return this.refresh_objects()
		},

		context_menu(selected_object, index, event)
		{
			event.preventDefault()

			this.selected_object = selected_object
			this.selected_text = event.srcElement.innerText
			this.$refs.context_menu.open(event)
		},

		double_click(selected_element)
		{
			if(this.single_element_url)
				this.$router.push('/' + this.single_element_url + '/' + selected_element.id)
		},

		open_in_new_tab(url)
		{
			window.open(url, "_blank")
		},

		// #############################################################################
		// Группировка

		set_group_many()
		{
			this.$refs.set_group_many.execute(this.service == "cadastral_analogues")
		},

		get_set_group_auto_many_params()
		{
			this.$refs.set_group_auto_many.execute()
		},

		set_group_auto_many(ev)
		{
			var params = {

				query : this.get_query(),
				all : ev.all,

			}

			if(this.$root.current_group)
				params.root_group = this.$root.current_group.group_id

			api.call_long_operation(this, this.essence + ". Множественное редактирование. Группировка", this.service, "set_group_auto_many", params,
				response =>
				{
					api.open_response_url(response)

					main_tree.create(this)

					this.refresh()
				},
				{ success_msg : `Операция группировки ${this.essence} на основании фильтров завершена` }
			)
		},

		// #############################################################################
		// Код расчета вида использования, функциональные группы / подгруппы

		set_evaluating_using_code_many()
		{
			this.$refs.set_evaluating_using_code_many.execute()
		},

		set_functional_group_sub_group_many()
		{
			this.$refs.set_functional_group_sub_group_many.execute()
		},

		set_active_service(step_id)
		{
			if (this.$route.name != step_id)
			{
				this.$router.replace({ name: step_id, query: this.$route.query })
					.catch((e) => {if (e.type != 2) console.error(e)})
			}
		},
	}
}

</script>

<style scoped>
.base_objects
{
	height: unset;
	flex: 1;
}

.base_objects:hover .footer_scroll::-webkit-scrollbar-thumb
{
	background-color: var(--bft-neutral-300) !important;
}

@-moz-document url-prefix() {
	.base_objects:hover .footer_scroll
	{
		scrollbar-color: var(--bft-neutral-300) transparent;
	}
}
.base_objects .navbar
{
	position: sticky;
	top: 0;
}
.base_objects .elements
{
	min-width: 100%;
}
.base_objects .elements >>> thead
{
	position: sticky;
	top: 56px;
	z-index: 1;
}
.base_objects .footer
{
	margin-top: auto;
	bottom: 0;
	position: sticky;
	background-color: white;
	z-index: 1;
}
.base_objects .footer_content
{
	padding-top: 1rem;
}
.base_objects .footer_count >>> .v-select:not(.vs--open) .vs__dropdown-toggle .vs__selected
{
	margin-top: 4px;
}
</style>
